var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pt-1",
      staticStyle: { height: "56px", "max-width": "56px" }
    },
    [
      _vm.avatars[0].network == "facebook"
        ? _c("wz-avatar", {
            staticClass: "pl-1",
            attrs: {
              username: _vm.avatars[0].username,
              src: _vm.avatars[0].src,
              size: "32px",
              isTyping: _vm.avatars[0].isTyping,
              lastMessage: _vm.avatars[0].lastMessage,
              chip: _vm.avatars[0].chip
            }
          })
        : _vm.avatars[0].network == "whatsapp"
        ? _c("wz-avatar", {
            staticClass: "pl-1",
            attrs: {
              username: _vm.avatars[0].username,
              src: _vm.avatars[0].src,
              size: "32px",
              isTyping: _vm.avatars[0].isTyping,
              lastMessage: _vm.avatars[0].lastMessage,
              chip: _vm.avatars[0].chip
            }
          })
        : _c("wz-avatar", {
            staticClass: "pl-1",
            attrs: {
              username: "#" + _vm.avatars[0].id,
              src: null,
              size: "32px",
              isTyping: _vm.avatars[0].isTyping,
              lastMessage: _vm.avatars[0].lastMessage,
              chip: _vm.avatars[0].chip
            }
          }),
      _vm._v(" "),
      _c("wz-avatar", {
        staticClass: "avatar-bottom",
        attrs: {
          username: _vm.avatars[1].username,
          src:
            _vm.domaine +
            "/public/media/user/small/" +
            _vm.avatars[1].id +
            "_avatar.jpg",
          size: "30px"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b903dd84", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b903dd84","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAvatarDouble.vue
// module id = null
// module chunks = 